import { Inventory, War, Bracket } from '../types';

export const STARTING_ELO = 1000;
export const STARTING_GOLD = 1000;

export const WAR_BRACKETS: Record<string, Bracket> = {
  SKIRMISH: {
    id: 'SKIRMISH',
    name: 'Skirmish',
    minCost: 50,
    maxCost: 100, // Fits Standard Army (approx 390)
    minElo: 0,
    baseCost: 50
  },
  CAMPAIGN: {
    id: 'CAMPAIGN',
    name: 'Campaign',
    minCost: 100,
    maxCost: 150,
    minElo: 1200,
    baseCost: 100
  },
  WAR: {
    id: 'WAR',
    name: 'Total War',
    minCost: 150,
    maxCost: 200, // Massive armies
    minElo: 1500,
    baseCost: 150
  }
};

export const CAPTURE_REWARDS = {
  p: 1,
  r: 3,
  n: 2,
  b: 2,
  q: 4,
  k: 1
};

export const PIECE_COSTS = {
  p: 1,
  n: 3,
  b: 3,
  r: 5,
  q: 9,
  k: 1,
};

// Explicit costs from prompt (Updated to Gold Standard)
export const DRAFT_COSTS = {
  p: 1,
  n: 3,
  b: 3,
  r: 5,
  q: 9,
  k: 1
};

export const STANDARD_BOARD_COUNTS: Inventory = {
  p: 8,
  n: 2,
  b: 2,
  r: 2,
  q: 1,
  k: 1
};

/**
 * Calculates total resources used for a given inventory.
 * Note: If K/Q are mandatory and unique, they might not consume resources or have a fixed cost.
 * Given the prompt "pawns cost 1 resource...", I will treat K/Q as free base units for the war.
 */
export const calculateCost = (inventory: Inventory): number => {
  let cost = 0;
  cost += inventory.p * DRAFT_COSTS.p;
  cost += inventory.n * DRAFT_COSTS.n;
  cost += inventory.b * DRAFT_COSTS.b;
  cost += inventory.r * DRAFT_COSTS.r;
  cost += inventory.q * DRAFT_COSTS.q;
  cost += inventory.k * DRAFT_COSTS.k;
  // King is free
  return cost;
};

export const checkWarVictory = (userInventory: Inventory, opponentPawns: number): 'VICTORY' | 'DEFEAT' | null => {
  // Defeat Condition 1: Less than 8 pawns (cannot form solid line)
  if (userInventory.p < 8) {
    return 'DEFEAT';
  }

  // Defeat Condition 2: (Removed - Replaced by King Deserter Mechanic)

  // Victory Condition: Opponent crushed (Simplified check based on Pawns)
  if (opponentPawns < 8) {
    return 'VICTORY';
  }

  return null;
};

export const PROFILE_TITLES = [
  { min: 0, title: 'Serf' },
  { min: 1200, title: 'Man-at-Arms' },
  { min: 1400, title: 'Squire' },
  { min: 1600, title: 'Knight' },
  { min: 1800, title: 'Knight Captain' },
  { min: 2000, title: 'Baron' },
  { min: 2200, title: 'Viscount' },
  { min: 2400, title: 'Earl' },
  { min: 2600, title: 'Duke' },
  { min: 2800, title: 'Grand Marshal' }
];

export const CODEX_QUOTES = [
  "In this court, mercy is not to be shown.",
  "A King without an army is no true King.",
  "Battles are won by valor, Wars are won by sacrifice.",
  "Every move counts, every piece is precious.",
  "The sword is heavy, but the crown is heavier.",
  "Victory favors the lucky few.",
  "Hope is a fools errand."
];

export const getProfileTitle = (rating: number): string => {
  const sorted = [...PROFILE_TITLES].sort((a, b) => b.min - a.min);
  const match = sorted.find(t => rating >= t.min);
  return match ? match.title : 'Serf';
};
